'use strict';

/**
 *
 * @name: wechat
 *
 */

import DirectiveTemplate from './nn-wechat-modal.directive.html';

function WechatModalDirective(
  $rootScope,
  $location,
  $timeout
) {

  'ngInject';

  return {
    restrict: 'E',
    template: DirectiveTemplate,
    link: function(scope, element) {

      /*
       *
       * @CONFIG
       *
       */

      var $modal = $(element).find('.modal');

      /*
       *
       * @PUBLIC
       *
       */

      /*
       *
       * @PRIVATE
       *
       */

      function _showMe() {

        $timeout(function() {

          $modal.removeClass('hidden');
        }, 10);
      }

      /*
       *
       * @INIT
       *
       */

      _showMe();
    }
  };
}

export default WechatModalDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modals/nn-wechat-modal/nn-wechat-modal.directive.js